class ExhibitionDataModel {
  constructor(props) {
    this.id = props.id;
    this.name = props.name;
  }
}

export default ExhibitionDataModel;
